var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLymphoma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7453 16.4034C14.9153 17.2534 14.5052 14.0334 14.5052 14.0334L16.3553 11.6934C19.9653 7.73341 17.6352 3.65341 13.2652 4.02341H13.2153C9.18525 4.88341 4.61524 9.22341 4.07524 13.5234C4.04524 13.7434 4.02524 13.9434 4.01524 14.1434C3.78524 17.0434 6.19525 19.3134 8.74525 18.5434C10.1253 18.1234 12.2753 16.1434 12.2753 16.1434C12.2753 16.1434 14.6652 20.2434 19.3252 19.1734",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4357 18.1433L8.0657 16.8433C7.8757 16.1933 8.0157 15.4933 8.4357 14.9533C8.4357 14.9533 9.14571 14.2233 9.24571 13.9033C9.32571 13.6733 9.24571 12.9233 9.24571 12.9233C9.24571 12.0833 9.7957 11.3533 10.5957 11.1033L11.7357 10.9933C12.2557 10.9433 12.7157 10.6233 12.9557 10.1533L13.3057 9.43329C13.9757 8.30329 15.0057 8.50329 15.8557 8.96329L17.2157 9.69329",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLymphoma);
export default __webpack_public_path__ + "static/media/Lymphoma.d7bba7c59b95917bc6bee8fcc45282bf.svg";
export { ForwardRef as ReactComponent };